import {
  convertToCamelCase,
  getFormattedDate,
} from "components/common/Utility";
import { Link } from "react-router-dom";

const PoLinkRenderer = (params) => {
  return (
    <Link to={`/poenquiry?poNo=${params.data.extOrderId}`}>{params.value}</Link>
  );
};

export const POSummaryColumnDefs = [
  {
    headerName: "",
    field: "selected",
    cellEditor: "agCheckboxCellEditor",
    editable: true,
    minWidth: 30,
    maxWidth: 32,
    flex: 1,
  },
  {
    headerName: "PO Identifier",
    valueGetter: (params) => {
      return params.data.orderId ? params.data.orderId : params.data.extOrderId;
    },
    type: "",
    cellRenderer: PoLinkRenderer,
    minWidth: 80,
    // maxWidth: 90,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "center-aligned-header",
    suppressNavigable: true,
  },
  {
    headerName: "Supplier Site Id",
    field: "supplierId",
    type: "numericColumn",
    minWidth: 80,
    // maxWidth: 90,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Destination Location",
    field: "shipToLocationId",
    type: "numericColumn",
    minWidth: 80,
    // maxWidth: 90,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "User",
    valueGetter: (params) => {
      return params.data.updatedBy
        ? params.data.updatedBy
        : params.data.createdBy;
    },
    type: "",
    headerClass: "center-aligned-header",
    minWidth: 200,
    // maxWidth: 160,
    flex: 2,
    filter: false,
    cellStyle: { textAlign: "left" },
    tooltipValueGetter: (params) => params.value,
    suppressNavigable: true,
  },
  {
    headerName: "Status",
    valueGetter: (params) => {
      return convertToCamelCase(params.data.status);
    },
    type: "",
    headerClass: "center-aligned-header",
    minWidth: 80,
    // maxWidth: 90,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "left" },
    tooltipValueGetter: (params) => params.value,
    suppressNavigable: true,
  },
  {
    headerName: "Created Date",
    valueGetter: (params) => {
      return getFormattedDate(params.data.createdAt);
    },
    type: "",
    minWidth: 80,
    // maxWidth: 90,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Order Date",
    valueGetter: (params) => {
      return getFormattedDate(params.data.orderDate);
    },
    type: "",
    minWidth: 80,
    // maxWidth: 90,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "center-aligned-header",
    suppressNavigable: true,
  },
  {
    headerName: "Delivery Date",
    valueGetter: (params) => {
      return getFormattedDate(params.data.deliveryDate);
    },
    type: "",
    minWidth: 80,
    // maxWidth: 90,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Handball",
    valueGetter: (params) => {
      return params.data.isHandball ? "Yes" : "No";
    },
    type: "",
    headerClass: "center-aligned-header",
    minWidth: 60,
    // maxWidth: 70,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "left" },
    suppressNavigable: true,
  },
  {
    headerName: "Import",
    valueGetter: (params) => {
      return params.data.isOverseas ? "Yes" : "No";
    },
    type: "",
    headerClass: "center-aligned-header",
    minWidth: 60,
    // maxWidth: 70,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "left" },
    suppressNavigable: true,
  },
  {
    headerName: "Total Case Qty",
    field: "totalCasesCount",
    type: "numericColumn",
    minWidth: 70,
    // maxWidth: 80,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Total Pallet Qty",
    field: "totalPalletCount",
    type: "numericColumn",
    minWidth: 70,
    // maxWidth: 80,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Total No of Wagons",
    field: "totalWagonsCount",
    type: "numericColumn",
    minWidth: 70,
    // maxWidth: 80,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Pallets per Wagon",
    field: "palletPerWagon",
    type: "numericColumn",
    minWidth: 70,
    // maxWidth: 80,
    flex: 1,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
];
